import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs';
import { LoginComponent } from 'src/app/components/login/login.component';
import { LoginService } from 'src/app/managers/login.service';
import { environment } from 'src/environments/environment';
import { OutputDataService } from 'src/app/common/services/output-data.service';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { ClientConfigService } from './common/services/client-config.service';
import { CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage'
import { MyProfileComponent } from './components/my-profile/my-profile.component';
//import { Store } from 'src/app/store/store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends BaseComponent implements OnInit, OnDestroy {
  platformName: string = environment.platformName;
  version: string = environment.platformVersion;
  applicationName: string = environment.titleToDisplay;
  isInLogin: boolean;
  private _onLoginSubscription: Subscription;
  private _menuOpened: boolean;

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _outputDataService: OutputDataService,
              private _snackBar: MatSnackBar, private _router: Router) {
    super(route, loginManager, clientConfig, dialog);
    this._menuOpened = true;
    this.isInLogin = false;
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.loginManager.clearUser();
    if (!this.undefinedOrNull(this._onLoginSubscription)) this._onLoginSubscription.unsubscribe();
  }

  @HostListener('window:beforeunload', ['$event']) 
  onBeforeUnload(event) {
    //console.log(this._loginManager.getLoggedinUser());
  }

  routerOutletComponentActivated(component) {
    if (component instanceof LoginComponent) {
      this._onLoginSubscription = component.onLogin.subscribe(x => {
        this.dataSource = this.loginManager.getLoggedinUser();
      });
      this.isInLogin = true;
    }

    this._menuOpened = true;
  }

  routerOutletComponentDeactivated(component) {
    if (component instanceof LoginComponent) {
      this._onLoginSubscription.unsubscribe();
      this.isInLogin = false;
    }
  }

  menuOpenClick() {
    this._menuOpened = !this._menuOpened;
    this._outputDataService.emitMenuOpened(this._menuOpened);
  }

  loginClick() {
    this._router.navigate(['/login/signin']);
    this.isInLogin = true;
  }

  signupClick() {
    this._router.navigate(['/login/signup']);
    this.isInLogin = true;
  }

  backHome() {
    this._router.navigate(['/home']);
  }

  async logoutClick() {
    this._snackBar.open('Signing out...');
    let responseMsg = await this.loginManager.logoutAsync();
    this._snackBar.dismiss();

    if (responseMsg.Status === CoreResponseStatus.OK) {
      this.dataSource = this.loginManager.getLoggedinUser();
      this._snackBar.open('Signed out successfully', 'Ok', { duration: 5000 });
      this._outputDataService.emitLogout();         
    }
    else {
      this._snackBar.open('Failed to sign out: ' + responseMsg.Message, 'Ok', { duration: 5000 });
      this.handleCoreResponseMessageError(responseMsg);
    }
  }

  getWelcome(): string {    
    if (this.isUserLogged()) {  
      let str = this.getLoggedinUser().Email.split('@', 2);
      return 'Welcome, ' + str[0];
    }
    else
      return '';   
  }

  myProfile() {
    const dialogRef = this.dialog.open(MyProfileComponent, {
      width: '500px',
      height: '350px',
      data: {
        parentComponent: 'AppComponent',
        dataSource: this.getLoggedinUser()
      }
    });

    dialogRef.afterClosed().subscribe(user => {
      if (!this.undefinedOrNull(user)) {
        this.loginManager.setLoggedinUser(user);
        this.dataSource = this.loginManager.getLoggedinUser();
      }
    });
  }

  appStoreClick() {
    window.open(this.clientConfig.Configuration.appStoreUrl);
  }
}
